





import { Component, Vue } from 'vue-property-decorator'

@Component({ components: {} })
export default class ViewAttempt extends Vue {
  popupAttemptId = ''

  handleOpen() {
    console.log('open')
  }

  handleClose() {
    this.reset()
  }

  reset() {
    console.log('reset')
  }
}
